import React, { useEffect } from "react";

import { TextField, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useState } from "react";
import fetchCoupon from "../../helpers/fetchCoupon";
import PriceComponent from "./priceComponent";
import memberShipPrice from "../../data/memberShipPrice";
import STANDARD_PRICE from "../../data/memberShipPrice";
import { useCouponContext } from "../../contexts/couponContext";

const CouponComponent: React.FC<{ couponId: string | undefined }> = ({ couponId }) => {
  const [couponText, setCouponText] = useState<string>("");
  const [validCoupon, setValidCoupon] = useState<boolean>(false);
  const [couponError, setCouponError] = useState<boolean>(false);
  const [couponPrice, setCouponPrice] = useState<number>(100);
  const [loadingState, setLoadingState] = useState<boolean>(false);
  const [couponHelperText, setCouponHelperText] = useState<string>("");
  const { updateCoupon } = useCouponContext();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("✨✨ PROPS", couponId);
    if (couponId) {
      setCouponText(couponId);
      checkCoupon(couponId);
    }
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCouponText(e.target.value);
  };

  const checkCoupon = async (couponName: string): Promise<boolean> => {
    setLoadingState(true);

    if (!couponName || couponName.trim() === "") {
      setValidCoupon(false);
      setCouponError(true);
      setCouponHelperText("Insira um cupom para validar");
      setLoadingState(false);
      return false;
    }

    const coupon = await fetchCoupon(couponName);

    if (!coupon || !("price" in coupon.fields)) {
      console.log("1");
      setValidCoupon(false);
      setCouponError(true);
      setCouponHelperText("Cupom inválido");
      setLoadingState(false);
      return false;
    } else {
      const couponPrice = coupon.fields.discountedPrice;
      if (couponPrice > STANDARD_PRICE) {
        setValidCoupon(false);
        setCouponError(true);
        setCouponHelperText("Cupom inválido");
        setLoadingState(false);
        return false;
      } else {
        setValidCoupon(true);
        setCouponError(false);
        setCouponPrice(couponPrice >= 0 ? couponPrice : 0);
        setCouponHelperText("Cupom válido");
        updateCoupon(coupon);
        setLoadingState(false);
        return true;
      }
    }
  };

  const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  const handleAssinarAgora = async () => {
    if (couponText.trim() !== "" && !validCoupon) {
      const isValid = await checkCoupon(couponText.toLocaleUpperCase());
      if (!isValid) {
        setCouponText("");
        return;
      }
      setLoadingState(true);
      await delay(4000);
    }
    navigate("/form");
  };

  return (
    <div className="coupon-component-container">
      <h3 className="header">Benefício Ana Health</h3>
      <PriceComponent price={memberShipPrice} validCoupon={validCoupon} newPrice={couponPrice} />

      <p className="sub-header">Por mês</p>
      <p className="sub-header">Um plano com tudo que você precisa com um valor que cabe no seu bolso</p>
      <div className="input-container">
        <TextField
          variant="outlined"
          label="Cupom"
          className="coupon-input"
          error={couponError}
          helperText={couponHelperText}
          value={couponText}
          onChange={handleChange}
        />
        <Button className="submit-button" disabled={loadingState} variant="contained" onClick={handleAssinarAgora}>
          ASSINAR AGORA
        </Button>
      </div>
    </div>
  );
};

export default CouponComponent;
